import * as moment from 'moment';
import { parseDate } from './date-utils';

/**
 * Get form data from form values, transforming dates and trimming strings
 */
export function getFormData(formValues: Record<string, unknown>, allowEmpty?: boolean): Record<string, any> {
  return Object.keys(formValues).reduce((data: any, field) => {
    let value = formValues[field];

    // Trim string values
    if (typeof value === 'string') {
      value = value.trim();
    }

    // Transform Date object to formatted date string
    if (value instanceof Date) {
      value = parseDate(value as any);
    }

    // Allow 0, false, etc. but skip null/undefined
    if (value !== null && value !== undefined && (value !== '' || allowEmpty)) {
      data[field] = value;
    }

    return data;
  }, {});
}

/**
 * Get difference values as object from comparison of the 2 object arguments
 */
export function getModelChanges(formValues: Record<string, unknown>, snapshot: any): Record<string, any> {
  return Object.keys(formValues).reduce((changes, field) => {
    if (typeof formValues[field] === 'string') {
      formValues[field] = (formValues[field] as string).trim();
    }
    return formValues[field] != snapshot[field] ? { ...changes, [field]: formValues[field] } : changes;
  }, {});
}

/**
 * Divide fields by 100 (for percentage conversion)
 */
export function divideFieldsBy100(value: any): any {
  if (value != null && !isNaN(value)) {
    value = value === 0 ? 0 : Number((value / 100).toFixed(6));
  }
  return value;
}

import { FormGroup } from '@angular/forms';

/**
 * Get updated form values (only dirty and touched fields)
 */
export function updatedForm(form: FormGroup) {
  const values: any = {};
  const mustCheckKeys = ['receiptAmount', 'paymentAmount'];

  Object.keys(form.controls).forEach((key) => {
    if (form.controls[key].dirty && form.controls[key].touched) {
      values[key] = form.value[key];
    }

    if (mustCheckKeys.includes(key) && form.controls[key].dirty) {
      mustCheckKeys.forEach((mustCheckKey) => {
        values[mustCheckKey] = form.value[mustCheckKey];
      });
    }
  });

  return values;
}
